//TODO - generate this version number on build from the package.json in the root of the project
export const spgiFusionInteropVersion = "0.5.0";
